import React from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Title from '../Common/Title';
import Link from '@mui/material/Link';
// import styles from '../../styles.css';

function DashboardTile({
  header,
  bigContent,
  smallContent,
  children,
  seeMore,
  setSeeMore,
  bigContentStyle,
  height,
}) {
  const boxShadowStyle = {
    boxShadow:
      '0 22px 25px 0 rgb(228 228 234 / 22%), 0 9px 23px 0 rgb(228 228 234 / 50%)',
    '&:hover': {
      boxShadow:
        '0 22px 32px 0 rgb(228 228 234 / 56%), 0 9px 28px 0 rgb(228 228 234 / 64%)',
    },
  };

  return (
    <Paper
      sx={[
        {
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          padding: '36px 48px',
          borderRadius: '12px',
          height: height || null,
          justifyContent: 'center',
        },
        boxShadowStyle,
      ]}
      elevation={24}>
      <TileBody
        bigContent={bigContent}
        header={header}
        smallContent={smallContent}
        bigContentStyle={bigContentStyle}
      />
      {children && children}
    </Paper>
  );
}

const TileBody = ({bigContent, header, smallContent, bigContentStyle}) => {
  return (
    <React.Fragment style={{justifyContent: 'center'}}>
      <Title>{header}</Title>
      {bigContent !== undefined && (
        <Typography
          component="p"
          variant="h4"
          sx={[
            {
              fontSize: '46px',
              fontWeight: '500',
              letterSpacing: '1.2px',
              lineHeight: '44px',
              margin: '30px 0 16px',
              textAlign: 'center',
            },
            bigContentStyle,
          ]}>
          {bigContent}
        </Typography>
      )}
      {smallContent !== undefined && (
        <Typography
          color="text.secondary"
          sx={{
            flex: 1,
            margin: '0px',
            color: 'rgb(157, 157, 176)',
            fontSize: '15px',
            fontWeight: '500',
            letterSpacing: '0.3px',
            lineHeight: '24px',
            alignSelf: 'center',
          }}>
          {smallContent}
        </Typography>
      )}
    </React.Fragment>
  );
};

export default DashboardTile;
